export default "__VITE_ASSET__MyvLZ$Lb__"